/**
 * `m:ss` formatter for compact in-player time readouts. Used by safe-zone
 * overlays that paint a current/duration string (LinkedIn Feed Post,
 * YouTube Long-Form). Negative or non-finite inputs floor to `0:00` so the
 * readout never reads as "−1:23" or "NaN:NaN" while the renderer warms up.
 *
 * Format intentionally matches what each platform's actual player paints:
 * minutes are not zero-padded (`1:05`, not `01:05`); seconds always are.
 * If a future platform uses a different shape (`h:mm:ss` for long-form),
 * add a sibling helper rather than parameterizing this one — keeps each
 * overlay's intent grep-able from the call site.
 */
export function formatPlaybackTime(seconds: number): string {
  const safe = Math.max(0, Math.floor(seconds));
  const m = Math.floor(safe / 60);
  const s = safe % 60;
  return `${m}:${s.toString().padStart(2, '0')}`;
}
